import { useUser } from "@saleor/auth";
import { useUserPermissions } from "@saleor/auth/hooks/useUserPermissions";
import { isStaffRole } from "@saleor/auth/hooks/useUserRole";
import { Zone } from "@saleor/auth/types";
import { changeOrderUrl } from "@saleor/changeOrder/urls";
import {
  ChangeOrderViewDomestic,
  OrderListView as OrderListViewDomestic
} from "@saleor/changeOrderDomestic";
import {
  ChangeOrderView,
  OrderListView,
  OrderProcessingView
} from "@saleor/changeOrderExport";
import {
  changeOrderPath,
  orderProcessing
} from "@saleor/changeOrderExport/urls";
import { WindowTitle } from "@saleor/components/WindowTitle";
import { PermissionEnum } from "@saleor/graphql";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Switch } from "react-router";

const ChangeOrderSection = () => {
  const intl = useIntl();
  const permissions = useUserPermissions();
  const { zone } = useUser();
  const isStaff = isStaffRole();

  const extensionsPermissionExport = permissions?.find(
    perm => perm.code === PermissionEnum.VIEW_ORDER_EXPORT
  );
  const extensionsPermissionDomestic = permissions?.find(
    perm => perm.code === PermissionEnum.VIEW_ORDER_DOMESTIC
  );

  const getOrderComponents = () => {
    if (
      !(extensionsPermissionExport && extensionsPermissionDomestic)
        ? extensionsPermissionExport && !extensionsPermissionDomestic
        : zone === Zone.Export
    ) {
      return OrderListView;
    } else if (
      !(extensionsPermissionExport && extensionsPermissionDomestic)
        ? !extensionsPermissionExport && extensionsPermissionDomestic
        : zone === Zone.Domestic
    ) {
      return OrderListViewDomestic;
    } else {
      return OrderListView;
    }
  };

  const getViewEditOrderComponents = () => {
    if (zone === Zone.Export) {
      return ChangeOrderView;
    } else if (zone === Zone.Domestic) {
      return isStaff ? ChangeOrderViewDomestic : ChangeOrderView;
    }
  };

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.changeOrder)} />
      <Switch>
        <Route exact path={changeOrderUrl} component={getOrderComponents()} />
        <Route
          exact
          path={changeOrderPath(":id")}
          render={getViewEditOrderComponents()}
        />
        <Route exact path={orderProcessing} component={OrderProcessingView} />
      </Switch>
    </>
  );
};

export default ChangeOrderSection;
